import React from "react";

import Logo from "../../../assets/images/logo_toptrading.png";
import { useCreateToptradingContext } from "../create/provider/createToptrading.provider";
import { useCreateNewsToptradingContext } from "../create/news/provider/createNewsToptrading.provider";
import { useCreateUsedToptradingContext } from "../create/used/provider/createUsedToptrading.provider";
import { useLoginUser } from "../../../hooks/useLoginUser";

const Navbar = () => {
  const { setFlow, setStep, step } = useCreateToptradingContext();
  const { handleInitialState: handleInitialStateNews } =
    useCreateNewsToptradingContext();
  const { handleInitialState: handleInitialStateUsed } =
    useCreateUsedToptradingContext();
  const { logout } = useLoginUser();

  const handleLogout = () => {
    setFlow("new");
    handleInitialStateUsed();
    handleInitialStateNews();
    logout();
    setStep(1);
  };

  return (
    <nav className={`fixed z-40 w-full bg-white`}>
      <div className="max-w-screen flex px-32">
        <div className="ml-10 flex w-full items-center justify-between px-5 lg:px-0">
          <div className="my-4 -ml-7 w-24 lg:ml-0 lg:w-52">
            <img
              alt="toptrading_acinco_logo"
              src={Logo}
              className="img-fluid w-full"
            />
          </div>
          {step > 2 && (
            <div className="text-center">
              <button
                type="button"
                className="text-center"
                onClick={() => handleLogout()}
              >
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
